import React from 'react'
import Fab from '@material-ui/core/Fab'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  fab: {
    height: 60,
    width: 60
  },
  icon: {
    height: 30,
    width: 30,
    color: theme.palette.primary.contrastText
  }
}))

function CloseButton (props) {
  const classes = useStyles()

  return (
    <Fab className={classes.fab} color='primary'>
      <CloseIcon className={classes.icon} />
    </Fab>
  )
}

export default CloseButton
